<template>
  <div class="hello">
    <div  class="page">
      <div >
        <div class="nav_box"></div>
        <div class="nav"><a href="#/" class="router-link-active"><img alt="" class="logo"
              src="@/assets/UploadFile/1/Img/2022620358521851191.png"></a> <a href="#/" class="router-link-active">
            <div>3D积木搭建手册</div>
          </a> <a href="#/en" class="lang_icn"><img src="/static/images/icn-03.png" class="icn"></a></div>
      </div>
      <div  class="list">
        <div  v-for="(item,index) in listData" class="">
          <!-- <div  class="list_title">
            {{item.Name}}
          </div> -->
          <div   class="">
            <div  v-for="(c_item,c_index) in item.list" v-on:click="jump (c_item.ID,c_item.Sort)" class="li">
              <div  class="list_item"><img  :alt="c_item['Name']"
                  :data-src="baseUrl+c_item.Pic"
                  :src="baseUrl+c_item.Pic" lazy="loaded">
                <div >{{c_item.Name}}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <!-- <footer  class="footer">3D拼装图纸</footer> -->
    <div  id="page-spinner" class="page-spinner" style="display: none;">
      <div class="vue-simple-spinner"
        style="margin: 0px auto; border-radius: 100%; border-width: 3px; border-style: solid; border-color: rgb(33, 150, 243) rgb(238, 238, 238) rgb(238, 238, 238); border-image: initial; width: 32px; height: 32px; animation: 0.8s linear 0s infinite normal none running vue-simple-spinner-spin;">
      </div>
      <div id="spinnertext" class="vue-simple-spinner-text"
        style="margin-top: 4px; color: rgb(255, 255, 255); font-size: 14px; text-align: center;">正在加载中...</div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'index',
  mounted () {
    let that = this;
    this.$http({
        method: "get",
        url: './static/getMassage/Handler/BookletData.json',
    }).then(res => {
        if (res.status == 200) {
          that.$set(that.$data, 'listData', res.data.data.list);
        }
    })
  },
  data () {
    return {
      baseUrl: 'http://aly.haominapp.com/',
      listData: {},
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    jump(Id,Sort) {
      if(Sort == '0'){
        this.$router.push({ name: 'lessonList', query: { id: Id } })
      } else {
        this.$router.push({ name: 'modelList', query: { id: Id } })
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.list {
    margin: 0 7rem
}
.list_item {
	width: 330rem;
    height: 420rem;
    background-color: #fff;
    border-radius: 10rem;
    float: left;
    margin: 15rem 19rem 15rem 19rem
}
</style>



// WEBPACK FOOTER //
// src/components/homeList.vue